import { RelatedEntityTypeEnum } from '@/types/schema';
import { IntegrationProviderEnum } from '@/types/schema';

export enum AddTaskMenuAction {
  // CreateNew = 'CREATE_NEW',
  ImportFromJira = 'IMPORT_FROM_JIRA',
  AutoSyncFromJira = 'AUTO_SYNC_FROM_JIRA',
  ImportFromExisting = 'IMPORT_FROM_EXISTING',
}

export const PROVIDER_IMPORT_ACTION_MAP: Record<string, AddTaskMenuAction> = {
  [IntegrationProviderEnum.Jira]: AddTaskMenuAction.ImportFromJira,
};

export const PROVIDER_AUTO_SYNC_ACTION_MAP: Record<string, AddTaskMenuAction> = {
  [IntegrationProviderEnum.Jira]: AddTaskMenuAction.AutoSyncFromJira,
};

export enum InViewActionDialog {
  AddTaskFromJira = 'AddTaskFromJira',
  AutoSyncFromJira = 'AutoSyncFromJira',
  AddTasks = 'AddTasks',
}

export interface AddTaskButtonProps {
  entityId?: string;
  entity?: RelatedEntityTypeEnum;
  fileId?: string | null;
  onClose: (props?: { refetchData?: boolean }) => void;
}
